import { ClientView, PersonType } from 'enums';

export enum ForeignIdType {
  NONE = '',
  PERSONAL = 'PERSONAL',
  NATIONAL = 'NATIONAL',
  PASSPORT = 'PASSPORT',
  CONCAT = 'CONCAT',
}

export interface AddressData {
  street: string;
  landRegistryNumber: string;
  houseNumber: string;
  city: string;
  postalCode: string;
  country: string;
}

export interface ContractOptions {
  countryCode: string[];
  citizenship: string[];
  identificationDocumentType: string[];
  taxResidencyCountry: string[];
  residencyBirthCountry: string[];
  gender: string[];
  naceCode: string[];
  residencePermitType: string[];
}

export interface ContractTaxData {
  taxResidency: {
    country: string;
    taxNumber: {
      number: string;
    };
  };
}

export interface Notifications {
    notificationMonthlyStatement: true,
    notificationYearlyStatement: true
}

interface ContractBasicData {
  readOnly: boolean;
  personType: PersonType;
  options: ContractOptions;
  clientView?: ClientView;
  notification: Notifications;
  employerAllowed?: boolean;
  bankData?: {};
  employerData?: {};
}

interface ContractAddresses {
  permanentAddress: AddressData;
  contactAndPermanentAddressesAreSame: boolean;
  contactAddress: AddressData;
  permanentAddressCompact?: string; // PDF
  contactAddressCompact?: string; // PDF
}

export interface ContractPersonalData extends ContractAddresses {
  firstname: string;
  lastname: string;
  gender: string;
  birthDate: string;
  personalNumber: string;
  degreePrefix: string;
  degreeSuffix: string;
  citizenship: string;
  foreignId: string;
  foreignIdType: ForeignIdType;
  placeOfBirth: string;
  countryOfBirth: string;
  email: string;
  phone: string;
  identificationDocument: {
    type: string;
    number: string;
    issuer: string;
    validFrom: string;
    validTo: string;
    issuingCountry: string;
    residencePermit: string;
  };
}

export interface ContractPhysicalData
  extends ContractBasicData,
    ContractPersonalData,
    ContractTaxData {}

export interface ContractLegalData extends ContractBasicData, ContractAddresses, ContractTaxData {
  companyName: string;
  companyNumber: string;
  legalEntityIdentifier: string;
  naceCode: string;
  registrationDate: string;
  registrationCountry: string;
  registrationPlace: string;
  representative: ContractPersonalData;
  email: string;
  phone: string;
}

export const initialAddress = {
  street: '',
  houseNumber: '',
  landRegistryNumber: '',
  city: '',
  postalCode: '',
  country: '',
};

const initialTax = {
  taxResidency: {
    country: '',
    taxNumber: {
      number: '',
    },
  },
};

// TODO: temp. fix for error handling
/*
const initialExt = {
  bankData: {},
  employerData: {}
};
*/

const initialPersonal = {
  firstname: '',
  lastname: '',
  gender: '',
  birthDate: '',
  personalNumber: '',
  degreePrefix: '',
  degreeSuffix: '',
  citizenship: '',
  foreignId: '',
  foreignIdType: ForeignIdType.NONE,
  placeOfBirth: '',
  countryOfBirth: '',
  permanentAddress: initialAddress,
  contactAddress: initialAddress,
  contactAndPermanentAddressesAreSame: true,
  email: '',
  phone: '',
  identificationDocument: {
    type: '',
    number: '',
    issuer: '',
    issuingCountry: '',
    validFrom: '',
    validTo: '',
  },
};

export const initialValuesPhysical = {
  ...initialPersonal,
  ...initialTax,
  //...initialExt
};

export const initialValuesLegal = {
  companyName: '',
  companyNumber: '',
  legalEntityIdentifier: '',
  naceCode: '',
  registrationDate: '',
  registrationPlace: '',
  registrationCountry: '',
  permanentAddress: initialAddress,
  contactAddress: initialAddress,
  representative: initialPersonal,
  ...initialTax,
 // ...initialExt
};
